import { render, staticRenderFns } from "./DeleteMemberDialog.vue?vue&type=template&id=72ce622a"
import script from "./DeleteMemberDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteMemberDialog.vue?vue&type=style&index=0&id=72ce622a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports